import { render, staticRenderFns } from "./tablaReferencias.vue?vue&type=template&id=6da2de32&scoped=true&"
import script from "./tablaReferencias.vue?vue&type=script&lang=js&"
export * from "./tablaReferencias.vue?vue&type=script&lang=js&"
import style0 from "./tablaReferencias.vue?vue&type=style&index=0&id=6da2de32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da2de32",
  null
  
)

export default component.exports